import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APICommonService } from '@nationwide/internet-servicing-angular-services';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { EnvironmentpickerService } from '../../../shared/services/environmentpicker.service';
import { LoggerService } from '../../../shared/services/logger.service';
import { TokenDataService } from '../../../shared/services/token-data.service';
import { UtilService } from '../../../shared/services/util.service';
import { CommercialLoggingService } from './commercial-logging.service';
@Injectable()
export class GetClaimsService {
    constructor(
        private apiCommonService: APICommonService,
        private httpClient: HttpClient,
        private apiCommon: APICommonService,
        private tokenDataService: TokenDataService,
        private util: UtilService,
        private LOGGER: LoggerService,
        private environmentPicker: EnvironmentpickerService,
        private commercialLoggingService: CommercialLoggingService
    ) { }
    getClaimContacts(claimNumber: string): Observable<any> {
        const getClaimsUrl = `${this.environmentPicker.getEnvironmentClaimsCenterApiURL() + environment.CLAIMS_API.ADJUSTER_SUMMARIES}${claimNumber}/adjuster-summaries`;
        return this.getInfo(getClaimsUrl, false);
    }
    getClaimEvents(claimNumber: string, queryParameters?: string): Observable<any> {
        let getClaimsUrl = `${this.environmentPicker.getEnvironmentClaimsCenterApiURL() + environment.CLAIMS_API.GET_BASIC_CLAIMS_DETAILS}claims/${claimNumber}/events`;
        if (queryParameters) {
            getClaimsUrl = getClaimsUrl + queryParameters;
        }
        return this.getInfo(getClaimsUrl, true);
    }

    getClaims(claimNumber: string): Observable<any> {
        const getClaimsUrl = `${this.environmentPicker.getEnvironmentClaimsCenterApiURL() + environment.CLAIMS_API.GET_BASIC_CLAIMS_DETAILS}claims/${claimNumber}`;
        return this.getInfo(getClaimsUrl, false);
    }

    getFinancialSummary(claimNumber: string): Observable<any> {
        const getClaimsUrl = `${this.environmentPicker.getEnvironmentClaimsCenterApiURL() + environment.CLAIMS_API.CLAIMS_BASE_FINANCIAL_API}claims/${claimNumber}/financial-summary`;
        return this.getInfo(getClaimsUrl, false);
    }
    getMetadata(): Observable<any> {
        const metadataBaseUrl = `${this.environmentPicker.getEnvironmentClaimsCenterApiURL()}${environment.CLAIMS_API.CLAIMS_METADATA_API}`;
        const getClaimsUrl = `${metadataBaseUrl}typelist?claim_resource=Financials&typelist_name=typekey.TransactionStatus`;
        return this.getInfo(getClaimsUrl, false);
    }

    getPayments(claimNumber: string, paymentStatuses: string, offset: any, limit: any): Observable<any> {
        const getClaimsUrl = `${this.environmentPicker.getEnvironmentClaimsCenterApiURL() + environment.CLAIMS_API.CLAIMS_BASE_FINANCIAL_API}claims/${claimNumber
            }/payments?offset=${offset}&limit=${limit}&costType=indemnity&status=${paymentStatuses}`;
        return this.getInfo(getClaimsUrl, true);
    }

    private getInfo(url: string, isPayments: boolean): any {
        const appClientId = environment.appProps.appClientId;
        const authToken = this.tokenDataService.getToken();
        const sessionId = window.sessionStorage.getItem('sessionId') || undefined;
        let headers = this.apiCommon.buildHeader({ appClientId, authToken, contentType: 'application/json', headerType: 'X-NW-Message-ID', sessionId });

        const serverId = this.environmentPicker.getEnvironmentServerNumber();
        if (serverId) {
            headers = headers.append('X-NW-Server-ID-Number', serverId);
        }
        headers = headers.append('X-NW-Message-ID', this.apiCommon.generateTransactionId());
        headers = headers.delete('x-nw-sessionid');
        this.commercialLoggingService.logServiceSuccess(
            this.LOGGER,
            'Commercial Claims Service',
            'GetClaimsService',
            'getInfoRequestBuilt',
            this.getServiceLogMetadata()
        );

        if (isPayments) {
            return this.httpClient.get<any>(url, { observe: 'response', headers })
                .pipe(map((response: any) =>
                    response),
                    catchError((error: HttpErrorResponse) => this.util.handleError(`Error getting claim information with URL: "${url}"`, error)));
        }

        return this.httpClient.get<any>(url, { headers })
            .pipe(map((response: any) =>
                response),
                catchError((error: HttpErrorResponse) => this.util.handleError(`Error getting claim information with URL: "${url}"`, error)));
    }

    private getServiceLogMetadata(additionalFields: any = {}): any {
        return {
            policyNumber: window.sessionStorage.getItem('claimsSelectedPolicyNumber') || '',
            policyType: window.sessionStorage.getItem('claimsPolicyType') || 'UNKNOWN',
            lineOfBusiness: window.sessionStorage.getItem('fnolFlow') || 'UNKNOWN',
            claimsDisplayCount: 'UNKNOWN',
            alphaState: 'UNKNOWN',
            previousUrl: window.sessionStorage.getItem('previousUrl') || '',
            ...additionalFields
        };
    }
}
